import logger from '../common/safe-log';

const VwoMappings = {
  'Select Bundle': {
    goal: 'selectBundle',
    property: 'bundleid'
  },
  'Yes To Inline Upsell': {
    goal: 'prepurchaseUpsell',
    property: 'accepted',
    value: true
  },
  'No To Inline Upsell': {
    goal: 'prepurchaseUpsell',
    property: 'accepted',
    value: false
  },
  'Presell-PopupAccept': {
    goal: 'discountPopup',
    property: 'accepted',
    value: true
  },
  'Presell-Popup Reject': {
    goal: 'discountPopup',
    property: 'accepted',
    value: false
  },
  'Initiate Checkout': {
    goal: 'initiateCheckout',
  },
  'Submit Order': {
    goal: 'completeOrder',
  },
  'Order Conversion': {
    goal: 'transaction',
    property: 'revenue'
  },
};

const module = 'VwoTracker';
const VwoTracker = {
  trackEvent: (eventProperties) => {
    try {

      window.VWO = window.VWO || [];
      window.VWO.event = window.VWO.event || function () {window.VWO.push(['event'].concat([].slice.call(arguments)))};

      const eventName = eventProperties.eventName;
      if (VwoMappings?.[eventName]) {

        const vwoGoal = VwoMappings[eventName].goal;

        let vwoProperty
        if(VwoMappings[eventName].property){
          const propertyName = VwoMappings[eventName].property;
          const propertyValue = eventProperties.propertyValue || VwoMappings[eventName].value;
          vwoProperty = {
            [propertyName] : propertyValue
          }
        }

        // add tracking event
        window.VWO.event(vwoGoal, vwoProperty);

      }
    } catch (e) {
      logger.error('trackEvent Failed', e, { module });
    }
  },
};
export default VwoTracker;